import { parseCookies } from 'nookies';

export const OPTIMIZELY_EDGE_COOKIE_NAME = 'optimizely_edge_experiments';
export const getOptimizelyEdgeExperiments = () => {
  if (typeof window === 'undefined') {
    return null;
  }
  const cookies = parseCookies();
  if (!cookies || typeof cookies !== 'object') {
    return null;
  }
  const optimizelyEdgeExperiments = cookies[OPTIMIZELY_EDGE_COOKIE_NAME];
  if (optimizelyEdgeExperiments) {
    try {
      return JSON.parse(optimizelyEdgeExperiments);
    } catch (error) {
      console.error('Failed to parse Optimizely experiments cookie:', error);
      return null;
    }
  }
  return null;
};
